import React, { FC, ReactElement } from 'react'
import { ComponentProductDto } from '~/modules/Products/Infrastructure/Dtos/ComponentProductDto'
import { TrophyCard } from '~/components/TrophyCard/TrophyCard'
import { ComponentTrophyDto } from '~/modules/Products/Infrastructure/Dtos/ComponentTrophyDto'
import styles from './index.module.scss'

interface Props {
  products: Array<ComponentProductDto>
  backlink?: boolean
  appearance?: 'default' | 'gallery'
}

export const Trophies: FC<Props> = ({ products, backlink, appearance = 'default' }) => {
  const content: ReactElement[] = products.map((product) => {
    return (
      <TrophyCard
        trophyDto={ product as ComponentTrophyDto }
        backlink={ backlink }
        appearance={ appearance }
        key={ product.id }
      />
    )
  })

  return (
    <div className={ styles.trophies__container }>
      { content }
    </div>)
}
